export const EDITOR_KEYBOARD_SHORTCUTS = [
    { key: 'Mod-z', descriptionKey: 'shortcut_undo' },
    { key: 'Mod-Shift-z', descriptionKey: 'shortcut_redo' },
    { key: 'Mod-y', descriptionKey: 'shortcut_redo_alt' },
    { key: 'Mod-Shift-x', descriptionKey: 'shortcut_strikethrough' },
];
//# sourceMappingURL=editor-keyboard-shortcuts.js.map